import { Fragment, Suspense, useEffect, useCallback } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./layouts/Layout/Layout";
import { publicRoutes } from "./routers/routes";
import { LoadComponent } from "./components";
import axios from "axios";
import { ConfigProvider } from "antd";
import "./i18n";
function App() {
  const them = {
    fontFamily: "Averta Std CY",
    fontSize: 16,
  }
  return (
    <ConfigProvider
      theme={{ token: them }}
    >
      <div className="App">
        <div id="__tooltip"></div>
        <Suspense fallback={<LoadComponent />}>
          <Routes>
            {publicRoutes.map((route, index) => {
              const DefaultLayout = route.layout ? Layout : Fragment
              const Page = route.component;
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <DefaultLayout>
                      <Page />
                    </DefaultLayout>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </div>
    </ConfigProvider>
  );
}

export default App;
